const module = { name: 'video/playlist', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_dtmData } from 'require-core';

const { dtmData } = Fandango_dtmData;


import { Fandango_queryUtil as Fandango_queryUtil_getParam_replaceParam_setParam } from 'require-core';

const { getParam, replaceParam, setParam } = Fandango_queryUtil_getParam_replaceParam_setParam;


import { global_consts as global_consts_QueryParams } from 'require-core';

const { QueryParams } = global_consts_QueryParams;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_debugLog as debugLog } from 'require-core';



import { fd_url_manager as links } from 'require-core';



import { Fandango_sanitizer as sanitizer } from 'require-core';



import { default as share } from 'swug-fdRequire-call:Fandango/share';



import { Fandango_xhr as xhr } from 'require-core';



import { default as videoEvents } from 'swug-fdRequire-call:video/events';



import { default as videoIframe } from 'swug-fdRequire-call:video/iframe';



import { default as redbandVerification } from 'swug-fdRequire-call:video/redbandVerification';



const Selectors = {
    CAROUSEL_PREVIOUS: '.js-jcarousel-prev',
    CAROUSEL_NEXT: '.js-jcarousel-next',
    PLAYLIST_ITEM: '.video-playlist__item',
    PLAYLIST_LINK: '.js-video-playlist-link',
    WRAP: '#vdlpVideoPlayerWrap',
}


let $carousel


let $module


let dtmDataPageName


let lastHistoryIndex = -1


let useHistory


let pausedVerifyIndex


let scrollSize = 1
function updateShareContent(meta) {
    if (share) {
        share.updateShareContent({
            description: meta.description,
            shareUrl: meta.href,
            title: meta.title
        });
    }
}
function updateShareMeta(meta) {
    const href = sanitizer.url(meta.href);
    const { description, title } = meta;
    $('link[rel="canonical"]').attr('href', href);
    $('meta[name="description"]').attr('content', description);
    $('meta[property="og:title"]').attr('content', title);
    $('meta[property="og:description"]').attr('content', description);
    $('meta[property="og:url"]').attr('content', href);
    $('meta[property="twitter:title"]').attr('content', title);
    $('meta[property="twitter:description"]').attr('content', description);
}
function updateSummary(meta) {
    $('.js-summary-video-title').html(meta.title);
    $('.js-summary-video-description').html(meta.description);
}
function forceFullyVisible($item) {
    $carousel.jcarousel('scroll', $item);
}
function updateCarousel($item, index) {
    $(Selectors.PLAYLIST_ITEM, $carousel).removeClass('video-playlist__item--active');
    $item.addClass('video-playlist__item--active');
    $('.js-jcarousel-index', $module).text(`${index} of ${$carousel.data('count')}`);
    forceFullyVisible($item);
}
function updateIframe($item, href, index) {
    lastHistoryIndex = index;
    dtmData.pageName = `${dtmDataPageName} | ${index || 'ad'}`;
    if (useHistory) {
        window.history.pushState({
            index
        }, 'goto-' + index, href);
    }
    videoIframe.load($item.data('iframe-url'), {
        autoplay: true
    });
    const meta = {
        movieId: $item.data('movie-id'),
        title: $('.video-playlist-thumb__title', $item).html().trim(),
        description: $('.video-playlist__description', $item).html().trim(),
        href
    };
    if (useHistory) {
        document.title = meta.title + ' | Fandango';
        updateShareMeta(meta);
    }
    updateShareContent(meta);
    updateSummary(meta);
    updateCarousel($item, index);
}
function onAgeVerification(ok) {
    if (!ok) {
        return;
    }
    const $item = $(`li[data-index=${pausedVerifyIndex}]`, $carousel);
    if (!$item.length) {
        return;
    }
    const href = $(Selectors.PLAYLIST_LINK, $item).attr('href');
    updateIframe($item, href, pausedVerifyIndex);
}
function onThumbnailClick(e) {
    if (useHistory && (!window.history || !window.history.pushState)) {
        return;
    }
    e.preventDefault();
    const $item = $(this).closest('li');
    const index = $item.data('index');
    if (!index) {
        return;
    }
    if ($item.data('mature') && !redbandVerification.ageOk()) {
        pausedVerifyIndex = index;
        redbandVerification.showAgeModal(onAgeVerification);
        return;
    }
    let queryParams = '';
    const videoId = $item.data('videoId');
    if (getParam(QueryParams.MPX_ID)) {
        queryParams = replaceParam(QueryParams.MPX_ID, videoId);
    }
    else {
        queryParams = '?' + setParam(QueryParams.MPX_ID, videoId);
    }
    const href = this.origin + this.pathname + queryParams;
    updateIframe($item, href, index);
}
function onVideoEndcardDone(data) {
    $(Selectors.WRAP).html(data);
}
function onVideoEndcardFail(err) {
    debugLog.warn(module.name, 'Video Endcard API Fail', err);
}
function displayEndcard(endcardId, mediaListId) {
    const queryParams = {};
    if (endcardId) {
        queryParams.endCardId = endcardId;
    }
    else if (mediaListId) {
        queryParams.mediaListId = mediaListId;
    }
    else {
        queryParams.mediaListId = 0;
    }
    const url = links.videoEndcardEndpoint({}, queryParams);
    xhr.ajax({
        url,
        type: 'get',
        dataType: 'html',
    })
        .done(onVideoEndcardDone)
        .fail(onVideoEndcardFail);
}
function onPrevBtnClick() {
    const backwardOffset = '-=' + scrollSize;
    $carousel.jcarousel('scroll', backwardOffset);
}
function onNextBtnClick() {
    const forwardOffset = '+=' + scrollSize;
    $carousel.jcarousel('scroll', forwardOffset);
}
function onCarouselAnimationEnd() {
    const disableNavClass = 'video-playlist__navigation--disabled';
    const isFirstVisible = parseInt($carousel.jcarousel('first').data('index'), 10) === 1;
    const isLastVisible = parseInt($carousel.jcarousel('last').data('index'), 10) === parseInt($carousel.data('count'), 10);
    $(Selectors.CAROUSEL_PREVIOUS, $module).toggleClass(disableNavClass, isFirstVisible);
    $(Selectors.CAROUSEL_NEXT, $module).toggleClass(disableNavClass, isLastVisible);
}
function prescroll() {
    const videoId = $module.data('current');
    if (!videoId) {
        return onCarouselAnimationEnd();
    }
    const $item = $(`.video-playlist__item[data-video-id="${videoId}"]`, $module)
        .addClass('video-playlist__item--active');
    $carousel.jcarousel('scroll', $item, false, onCarouselAnimationEnd);
}
function autoplayNext(data) {
    const $current = $(`.video-playlist__item[data-video-id=${data.video.videoID}]`);
    const $next = $(`.video-playlist__item[data-index=${$current.data('index') + 1}]`);
    if ($next && $next.length) {
        const $link = $(Selectors.PLAYLIST_LINK, $next);
        if ($link && $link.length) {
            $link.trigger('click');
        }
    }
    else if ($carousel.data('show-endcard')) {
        displayEndcard();
    }
}
function onPlaceholderClick(data) {
    if (lastHistoryIndex > -1) {
        return;
    }
    const $item = $(`.video-playlist__item[data-iframe-url="${data.playerSrc}"]`, $carousel);
    const index = $item.data('index');
    updateCarousel($item, index);
}
function onResize() {
    scrollSize = $('.js-playlist-jcarousel').jcarousel('fullyvisible').length;
}
function init() {
    $module = $('#video-playlist-module');
    $carousel = $('.js-playlist-jcarousel', $module);
    useHistory = $carousel.data('use-history');
    dtmDataPageName = dtmData ? dtmData.pageName : '';
    $carousel.jcarousel();
    $carousel.on('jcarousel:animateend', onCarouselAnimationEnd);
    $(Selectors.CAROUSEL_PREVIOUS, $module).on('click', onPrevBtnClick);
    $(Selectors.CAROUSEL_NEXT, $module).on('click', onNextBtnClick);
    $(Selectors.PLAYLIST_LINK, $carousel).on('click', onThumbnailClick);
    prescroll();
    onResize();
    $(window).on('resize', $.debounce(250, onResize));
    if (videoEvents) {
        if ($carousel.data('continous-play')) {
            videoEvents.onVideoEnd(autoplayNext);
        }
        videoEvents.onPlaceholderClick(onPlaceholderClick);
    }
}
module.exports = {
    init,
};
export default module.exports;